import { CssBaseline } from '@mui/material';
import './App.css';
import Router from './routes';
import AppTheme from './theme/AppTheme';

export default function App(props: Readonly<{ disableCustomTheme?: boolean }>) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Router />
    </AppTheme>
  );
}
